import { cn } from "@/lib/utils";
import Link from "@app/_components/Link";
import { useMarket } from "@app/_context";
import useTranslate from "@app/_hooks/useTranslate";
import { Button } from "@ui/button";
import { AnimatePresence, m } from "framer-motion";
import { HeartIcon } from "lucide-react";
import type { ComponentProps } from "react";
import useWishlist from "../../hooks/useWishlist";

export default function WishlistButton({
  showLabel = false,
  className,
  ...props
}: ComponentProps<typeof Button> & { showLabel?: boolean }) {
  const t = useTranslate();
  const { data } = useWishlist();
  const { market } = useMarket().state;

  return (
    <Button
      className={cn("relative h-auto w-auto p-1 transition-none", className)}
      variant="link"
      size={showLabel ? undefined : "icon"}
      asChild
      {...props}
    >
      <Link
        locale={market.locale}
        href="/account/wishlist"
        className="flex items-center gap-x-2"
      >
        <span className="sr-only">{t("wishlist")}</span>
        <div className="relative">
          <AnimatePresence>
            {!showLabel && !!data?.metadata?.totalItems && (
              <m.span
                key={data?.metadata?.totalItems}
                className="font-inline absolute -top-1 -right-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-black px-1 text-xs leading-none font-bold text-white tabular-nums"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                exit={{ scale: 0 }}
                transition={{
                  duration: 0.2,
                  scale: {
                    type: "spring",
                    stiffness: 200,
                    damping: 15,
                  },
                }}
              >
                {data?.metadata?.totalItems}
              </m.span>
            )}
          </AnimatePresence>
          <HeartIcon strokeWidth={1} className="size-5" />
        </div>
        {showLabel && (
          <span>
            {t("saveForLater")} ({data?.metadata?.totalItems})
          </span>
        )}
      </Link>
    </Button>
  );
}
